import { memo, useMemo } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import useLocalStorage from '../../../../hooks/useLocaleStorage';
import BlocError from '../../../shared/Error/BlocError';
import { Text } from '../../../../library';
import { bool } from 'prop-types';

export const NavigatorNotCompatible = memo(({ showButtonContactSupport = true }) => {
	const { t } = useTranslation();
	const [localToken] = useLocalStorage('localToken');
	const download = useMemo(() => t('Download'), [t]);

	return (
		<BlocError title={t('Browser not compatible')} button={null}>
			<Text data-testid="navigator-not-compatible" mb={1}>
				{t('Your browser is not compatible with our video technology.')}
			</Text>
			<Text>{t('Please use a compatible browser such as Chrome or Firefox.')}</Text>
			<Text>{t('For an optimal experience, please also avoid using private browsing.')}</Text>
			<Text>{`${window.location.origin}/start/${localToken}`}</Text>
			<ul>
				<li>
					<a data-testid="link-to-chrome" href="https://chrome.google.com">
						{download} Google Chrome
					</a>
				</li>
			</ul>
		</BlocError>
	);
});

NavigatorNotCompatible.propTypes = {
	showButtonContactSupport: bool,
};

export default NavigatorNotCompatible;
